import { Topbar } from "@/components/Topbar";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Products } from "@/components/Products";
import { Configurator } from "@/components/Configurator";
import { References } from "@/components/References";
import { About } from "@/components/About";
import { Partners } from "@/components/Partners";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Topbar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Configurator />
        <References />
        <About />
        <Partners />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
